import { createContext, useContext, useEffect, useState } from 'react';
import { authApi, cartApi, wishlistApi } from '../api/endpoints';

const AuthContext = createContext(null);

async function mergeLocalBags() {
  try {
    const localCart = JSON.parse(localStorage.getItem('nv_cart') || '[]');
    const localWish = JSON.parse(localStorage.getItem('nv_wishlist') || '[]');
    if (localCart.length) {
      await cartApi.sync(
        localCart.map((i) => ({
          productId: i.productId || i.product?._id,
          size: i.size || '',
          quantity: i.quantity || 1,
        }))
      );
      localStorage.removeItem('nv_cart');
    }
    if (localWish.length) {
      await wishlistApi.sync(localWish.map((p) => p._id || p));
      localStorage.removeItem('nv_wishlist');
    }
  } catch {
    // non-blocking
  }
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('nv_token');
    if (!token) {
      setLoading(false);
      return;
    }
    authApi
      .me()
      .then((res) => setUser(res.data.data))
      .catch(() => {
        localStorage.removeItem('nv_token');
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (identifier, password) => {
    const res = await authApi.login({ identifier, password });
    localStorage.setItem('nv_token', res.data.data.token);
    await mergeLocalBags();
    setUser(res.data.data.user);
    return res.data.data;
  };

  const register = async (payload) => {
    const res = await authApi.register(payload);
    localStorage.setItem('nv_token', res.data.data.token);
    await mergeLocalBags();
    setUser(res.data.data.user);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('nv_token');
    setUser(null);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        login,
        register,
        logout,
        isLoggedIn: !!user,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
